import { defaultScheduler } from '../scheduler/defaultScheduler';
export class BasicSubscription {
    constructor(source, sink) {
        this.source = source;
        this.sink = sink;
        this.disposable = source.run(sink, defaultScheduler);
    }
    static create(source, sink) {
        return new BasicSubscription(source, sink);
    }
    unsubscribe() {
        this.disposable.dispose();
    }
}
//# sourceMappingURL=BasicSubscription.js.map